<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 animate-fade-in shadow-none">
        <div class="card-body p-3">
          <div class="d-flex flex-row flex-wrap justify-content-between align-items-center mb-4">
            <div>
              <h1 class="card-title mb-1">Farmers</h1>
              <span class="sub-text">Track all farmers information</span>
            </div>

            <div class="d-flex gap-2">
              <button
                class="btn btn-soft-primary d-flex align-items-center gap-2"
                (click)="onExportFarmers()"
                [disabled]="isExportingFarmers">
                @if (isExportingFarmers) {
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Exporting...
                } @else {
                  <i class="bi bi-download"></i>
                  Export Farmers
                }
              </button>
              <button class="btn btn-soft-primary" routerLink="employee-farmers">
                <i class="bi bi-people"></i>
                <span>Employee Wise Farmers Visits</span>
              </button>
            </div>
          </div>

          <!-- Modern Filter Bar -->
          <div class="row g-3 mb-4">
            <div class="col-12 px-0">
              <div class="input-group">
                <span class="input-group-text bg-white border-end-0 ps-3 rounded-0">
                  <i class="bi bi-search text-muted"></i>
                </span>
                <input
                  type="text"
                  class="form-control ps-2 rounded-0 border-start-0"
                  placeholder="Search by farmer name or village..."
                  [(ngModel)]="searchTerm"
                  (keyup)="onSearchKeyUp()" />
              </div>
            </div>
          </div>

          <div class="bg-light border p-3 mb-4">
            <div class="row flex-row-reverse g-2">
              <div class="col-12 col-md-2">
                <ng-select
                  placeholder="All States"
                  [items]="states"
                  [(ngModel)]="selectedState"
                  [clearable]="true"
                  [searchable]="true"
                  (ngModelChange)="onFilterChange()" />
              </div>

              <div class="col-12 col-md-2">
                <ng-select
                  placeholder="All Districts"
                  [items]="districts"
                  [(ngModel)]="selectedDistrict"
                  [clearable]="true"
                  [searchable]="true"
                  (ngModelChange)="onFilterChange()" />
              </div>

              <div class="col-12 col-md-2">
                <ng-select
                  placeholder="All Talukas"
                  [items]="talukas"
                  [(ngModel)]="selectedTaluka"
                  [clearable]="true"
                  [searchable]="true"
                  (ngModelChange)="onFilterChange()" />
              </div>

              <div class="col-12 col-md-2">
                <ng-select
                  placeholder="All Villages"
                  [items]="villages"
                  [(ngModel)]="selectedVillage"
                  [clearable]="true"
                  [searchable]="true"
                  (ngModelChange)="onFilterChange()" />
              </div>

              <div class="col-12 col-md-2">
                <ng-select
                  placeholder="All Products"
                  [items]="products"
                  [(ngModel)]="selectedProduct"
                  bindValue="id"
                  bindLabel="name"
                  [clearable]="true"
                  [searchable]="true"
                  (ngModelChange)="onFilterChange()" />
              </div>

              <div class="col-12 col-md-2">
                <app-multi-select-dropdown
                  [options]="crops"
                  placeholder="Select Crops"
                  (selectionChange)="onCropsSelected($event)"></app-multi-select-dropdown>
              </div>
            </div>
          </div>

          @if (isFarmersDataLoading) {
            <app-loading-spinner></app-loading-spinner>
          } @else {
            <div class="table-responsive bg-white">
              @if ((farmers || []).length === 0) {
                <div class="empty-state-container">
                  <i class="bi bi-person-video2"></i>
                  <h5>No Farmers Found</h5>
                  <p>Try adjusting your search filters to find farmers.</p>
                </div>
              } @else {
                <table class="table table-hover align-middle mb-0">
                  <thead class="bg-light">
                    <tr>
                      <th class="ps-4 py-3">#</th>
                      <th class="py-3">Full Name</th>
                      <th class="text-end py-3">Mobile</th>
                      <th class="text-end py-3">WhatsApp</th>
                      <th class="text-end py-3">Village</th>
                      <th class="text-end py-3">Taluka</th>
                      <th class="text-end py-3">District</th>
                      <th class="text-end py-3">State</th>
                      <th class="text-end py-3">Crops Grown</th>
                      <th class="text-end pe-4 py-3">Land Size (Acre)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let farmer of farmers; let i = index" class="cursor-pointer" [routerLink]="farmer.id">
                      <td class="ps-4 py-3">{{ rowNumber(i) }}</td>
                      <td class="py-3 fw-semibold">{{ farmer.full_name | titlecase }}</td>
                      <td class="text-end py-3">{{ farmer.mobile_number }}</td>
                      <td class="text-end py-3">{{ farmer.whatsapp_number }}</td>
                      <td class="text-end py-3">{{ farmer.vilage }}</td>
                      <td class="text-end py-3">{{ farmer.taluka }}</td>
                      <td class="text-end py-3">{{ farmer.district }}</td>
                      <td class="text-end py-3">{{ farmer.state }}</td>
                      <td class="text-end py-3">{{ farmer.crops_grown.join(', ') | titlecase }}</td>
                      <td class="text-end pe-4 py-3">{{ +farmer.land_size | number: '1.0-0' }}</td>
                    </tr>
                  </tbody>
                </table>

                @if ((farmers || []).length > 0) {
                  <div class="mt-4">
                    <app-pagination
                      [currentPage]="currentPage"
                      [totalCount]="totalCount"
                      [pageSize]="pageSize"
                      [hasNextPage]="hasNextPage"
                      [hasPreviousPage]="hasPreviousPage"
                      (pageChange)="onPageChange($event)"></app-pagination>
                  </div>
                }
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<!-- WhatsApp Message Modal -->
<ng-template #whatsappModal let-modal>
  <div class="modal-content border-0">
    <div class="modal-header">
      <h5 class="modal-title">Send Message</h5>
      <button type="button" class="btn-close" (click)="closeModal()" [disabled]="isSending"></button>
    </div>

    <div class="modal-body p-4">
      <div class="form-check mb-3 pb-3 border-bottom">
        <input
          class="form-check-input"
          type="checkbox"
          id="selectAll"
          [(ngModel)]="selectAll"
          (change)="toggleSelectAll()"
          [disabled]="isSending" />
        <label class="form-check-label fw-bold cursor-pointer" for="selectAll">
          Select All Farmers ({{ farmersList.length }})
        </label>
      </div>

      <div class="mb-3">
        <label class="form-label fw-semibold">Select Farmers:</label>
        <div
          class="farmers-list bg-light"
          style="max-height: 250px; overflow-y: auto; border: 1px solid #dee2e6; padding: 0.75rem">
          <div *ngIf="isLoading" class="text-center py-3">
            <app-loading-spinner [inline]="true" class="mb-2"></app-loading-spinner>
            <p class="mb-0 text-muted">Loading farmers...</p>
          </div>

          <div *ngIf="!isLoading && farmersList.length === 0" class="text-center py-3 text-muted">
            No farmers available
          </div>

          <div *ngIf="!isLoading && farmersList.length > 0">
            <div class="form-check mb-2" *ngFor="let farmer of farmersList">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'farmer-' + farmer.id"
                [checked]="isFarmerSelected(farmer.id)"
                (change)="toggleFarmerSelection(farmer.id)"
                [disabled]="isSending" />
              <label class="form-check-label w-100 cursor-pointer" [for]="'farmer-' + farmer.id">
                <div class="d-flex justify-content-between align-items-center">
                  <span>{{ farmer.full_name }}</span>
                  <small class="text-muted">
                    <i class="bi bi-whatsapp ms-2 me-1"></i>
                    {{ farmer.whatsapp_number || farmer.mobile_number }}
                  </small>
                </div>
              </label>
            </div>
          </div>
        </div>
        <small class="text-muted mt-1 d-block">{{ selectedFarmerIds.length }} farmer(s) selected</small>
      </div>

      <div class="mb-3">
        <label for="message" class="form-label fw-semibold">Message:</label>
        <textarea
          class="form-control"
          id="message"
          rows="4"
          [(ngModel)]="message"
          placeholder="Type your message here..."
          [disabled]="isSending"
          maxlength="1000"></textarea>
        <small class="text-muted text-end d-block">{{ message.length }}/1000 characters</small>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeModal()" [disabled]="isSending">Cancel</button>
      <button
        type="button"
        class="btn btn-primary btn-enjochem"
        (click)="sendWhatsAppMessage()"
        [disabled]="isSending || selectedFarmerIds.length === 0 || !message.trim()">
        <span *ngIf="!isSending">
          <i class="bi bi-send me-1"></i>
          Send Message
        </span>
        <span *ngIf="isSending">
          <app-loading-spinner [inline]="true" class="me-1"></app-loading-spinner>
          Sending...
        </span>
      </button>
    </div>
  </div>
</ng-template>
